import React, { useState } from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import {
  displayField,
  isNotEmpty,
  isEmptyVal,
  processMinute,
  displayDayDateField,
} from "../../../utils/helpers";
import Followup from "../../Modules/Followups/Followup";

const FollowUpCell = ({
  rowData,
  positionFromRight = "50",
  withFirstOrder = true,
  onFollowup,
  ...props
}: {
  rowData: any;
  positionFromRight?: any;
  withFirstOrder?: boolean;
  onFollowup?: Function;
}) => {
  const { t } = useTranslation();
  const { Cell } = Table;
  const [openModalByName, setOpenModalByName] = useState("");
  const handleEvent = (eventKey: any) => {
    setOpenModalByName(eventKey);
  };
  const followUpNotes = isNotEmpty(rowData.notes) ? rowData.notes : "";
  const speaker = isNotEmpty(rowData.follow_up_id) ? (
    <Popover title={t("FOLLOW") + " " + t("UPS") + ":"}>
      <p>
        <b>{t("FOR")}:</b>
        <p> {displayField(rowData.follow_up_for)}</p>
      </p>
      <p>
        <b>{t("STATUS")}:</b>
        <p> {displayField(rowData.follow_up_status)}</p>
      </p>
      <p>
        <b>
          {t("NEXT")} {t("DATE")} :
        </b>{" "}
        <p>{displayDayDateField(rowData.follow_up_date)}</p>
      </p>
      <p>
        <b>{t("NOTES")} :</b> <br />
        <p>{displayField(followUpNotes)}</p>
      </p>
      <p>
        <a  className="pointer"
          onClick={() => {
            if (+rowData.follow_up_id > 0) handleEvent("manage-follow-up");
          }}
        >
          <b>{t("EDIT")}</b>
        </a>
      </p>
    </Popover>
  ) : (
    <Popover title={t("NEXT") + " " + t("FOLLOW") + " " + t("UP") + ":"}>
      <p>{t("NA")}</p>
    </Popover>
  );
  return (
    <Cell {...props}>
      <Whisper
        placement="top"
        speaker={speaker}
        enterable={true}
        preventOverflow={true}
      >
        <a>{displayDayDateField(rowData.follow_up_date)}</a>
      </Whisper>
      {openModalByName === "manage-follow-up" && (
        <Followup
          openModal={openModalByName === "manage-follow-up" ? true : false}
          setOpenModal={setOpenModalByName}
          rowData={rowData}
          followupId={rowData.follow_up_id}
          onFollowup={onFollowup}
        />
      )}
    </Cell>
  );
};

export default FollowUpCell;
